<template>
  <v-card flat class="futuristic-card">
    <v-card-title class="card-header">
      <h4 class="earth-color">GUEST REVENUE OVERVIEW</h4>
      <div class="title-decoration"></div>
    </v-card-title>
    <v-layout row wrap>
      <v-flex lg6 md6 sm12 xs12>
        <v-container>
          <h6 class="earth-color">
            Bookings Revenue ({{ currency }} {{ $roundOff(bookingsTotalData) }})
          </h6>
          <v-container>
            <ve-pie
              :data="bookingsRevenueData"
              :settings="chartSettingsRevenue"
              class="futuristic-chart"
            ></ve-pie>
          </v-container>
        </v-container>
      </v-flex>
      <v-flex lg6 md6 sm12 xs12>
        <v-container>
          <h6 class="earth-color">
            Transactions ({{ currency }} {{ $roundOff(transactionTotalData) }})
          </h6>
          <v-container>
            <ve-pie
              :data="transactionsData"
              :settings="chartSettingsRevenue"
              class="futuristic-chart"
            ></ve-pie>
          </v-container>
        </v-container>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex lg6 md6 sm12 xs12>
        <v-container>
          <h6 class="earth-color">
            Bookings Discounts ({{ currency }} {{ $roundOff(discountTotalData) }})
          </h6>
          <v-container>
            <ve-pie
              :data="bookingsRevenueDiscount"
              :settings="chartSettingsRevenue"
              class="futuristic-chart"
            ></ve-pie>
          </v-container>
        </v-container>
      </v-flex>
    </v-layout>
  </v-card>
</template>

<script>
export default {
  name: "GuestRevenueReport",
  data() {
    return {
      chartSettings: {
        metrics: ["number"],
        dataOrder: {
          label: "number",
          order: "asc",
        },
      },
      chartSettingsRevenue: {
        metrics: ["amount"],
        dataOrder: {
          label: "amount",
          order: "asc",
        },
      },
      menu1: false,
      modal1: false,
      menu2: false,
      modal2: false,
      loading: true,
      today: this.$moment.now(),
      revenue_date: {
        start_date: this.$moment(this.today).format("YYYY-MM-DD"),
        end_date: this.$moment(this.today).format("YYYY-MM-DD"),
        currency: this.$store.state.CurrencyStore.browser_currency_id,
      },
    };
  },
  computed: {
    currency() {
      return this.$store.state.CurrencyStore.browser_currency || 'KSH';
    },
    residencyRevenueCountData: function () {
      var data = this.$store.state.ChartStore.residency_count;
      var columns = ["name", "number"];
      var revenueData = [];
      revenueData.push(data);
      return {
        columns: columns,
        rows: data,
      };
    },
    bookingsRevenueData: function () {
      var data = this.$store.state.ChartStore.bookings_revenue;
      var columns = ["name", "amount"];
      var revenueData = [];
      revenueData.push(data);
      return {
        columns: columns,
        rows: data,
      };
    },
    bookingsRevenueDiscount: function () {
      var data = this.$store.state.ChartStore.bookings_discounts;
      var columns = ["name", "amount"];
      var revenueData = [];
      revenueData.push(data);
      return {
        columns: columns,
        rows: data,
      };
    },
    discountTotalData: function () {
      let data = this.$store.state.ChartStore.discount_total;
      if (data != undefined && data.length > 0) {
        return data[0];
      } else {
        return 0;
      }
    },
    bookingsTotalData: function () {
      let data = this.$store.state.ChartStore.bookings_total;
      if (data != undefined && data.length > 0) {
        return data[0];
      } else {
        return 0;
      }
    },
    transactionsData: function () {
      var data = this.$store.state.ChartStore.transaction_data;
      var columns = ["name", "amount"];
      var revenueData = [];
      revenueData.push(data);
      return {
        columns: columns,
        rows: data,
      };
    },
    transactionTotalData: function () {
      let data = this.$store.state.ChartStore.transaction_total;
      if (data != undefined && data.length > 0) {
        return data[0];
      } else {
        return 0;
      }
    },
  },
  created() {
    this.$store.dispatch("get_bookings_revenue_chart", this.revenue_date);
  },
};
</script>

<style scoped>
/* Futuristic Card */
.futuristic-card {
  border-radius: 8px;
  background: #ffffff;
  transition: all 0.3s ease;
}

.futuristic-card:hover {
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
}

.card-header {
  background: linear-gradient(45deg, #e8eaf6, #f5f7fa);
  padding: 16px;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
}

.earth-color {
  color: #587e27;
  font-weight: 600;
  margin: 0;
  font-size: 1.5rem;
}

.earth-color.h6 {
  font-size: 1.2rem;
}

.title-decoration {
  height: 4px;
  background: linear-gradient(90deg, #587e27, transparent);
  margin-top: 8px;
  width: 100px;
}

.futuristic-chart {
  border-radius: 8px;
  padding: 8px;
  background: #f5f7fa;
}

/* Responsive adjustments */
@media (max-width: 960px) {
  .futuristic-card {
    padding: 12px;
  }

  .card-header {
    padding: 12px;
  }

  .earth-color {
    font-size: 1.25rem;
  }

  .earth-color.h6 {
    font-size: 1rem;
  }

  .futuristic-chart {
    padding: 6px;
  }
}

@media (max-width: 600px) {
  .futuristic-card {
    padding: 8px;
    border-radius: 6px;
  }

  .card-header {
    padding: 8px;
  }

  .earth-color {
    font-size: 1.1rem;
  }

  .earth-color.h6 {
    font-size: 0.9rem;
  }

  .futuristic-chart {
    padding: 4px;
  }
}
</style>
